import React from 'react'

// material ui
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

// components
import LimitedAvailabilityModalContainer from './LimitedAvailabilityModalContainer'

// Renders a per-plan soft-close peak-period notice.
// `restriction` comes from the plan's `softCloseRestriction` GraphQL field and
// is null when the plan's location has no soft-closed peak periods in effect.
// `sessionId` and `registeredAt` are used to lazily load and filter the full
// list of limited-availability locations shown in the modal (a plan is only
// restricted by periods soft-closed on or before it was registered).
const SoftCloseRestrictionNotice = props => {
  const { restriction, sessionId, registeredAt } = props

  const [modalOpen, setModalOpen] = React.useState(false)

  if (!restriction) return null

  const { affected, locationName, restrictedDateRanges, unaffectedMessage } =
    restriction

  if (!affected) {
    return (
      <Alert severity='success' sx={{ mt: 1 }}>
        {unaffectedMessage}
      </Alert>
    )
  }

  return (
    <Alert severity='warning' sx={{ mt: 1 }}>
      <Typography variant='body2' gutterBottom>
        Day passes are not valid at <strong>{locationName}</strong> on these
        dates: <strong>{restrictedDateRanges.join(', ')}</strong>.
      </Typography>

      <Typography variant='body2'>
        For a complete list of additional locations and dates with limited
        availability,{' '}
        <Link component='button' onClick={() => setModalOpen(true)}>
          click here
        </Link>
        .
      </Typography>

      <LimitedAvailabilityModalContainer
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        sessionId={sessionId}
        registeredAt={registeredAt}
      />
    </Alert>
  )
}

export default SoftCloseRestrictionNotice
